import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FilterForm } from 'src/app/models/FilterForm';
import { Item } from 'src/app/models/item';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { MenuService } from 'src/app/services/menu.service';
import { ReportService } from 'src/app/services/report.service';
import * as moment from 'moment';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent {

  reportList:any=[];
  required_input_fields?:FilterForm;  
  requestData:FilterForm={};
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
  reportTitle="";
  today = new Date();
  selectedStartDate:any = moment(this.today).add(-7, 'days').format();
  selectedEndDate:any = this.today;
  showLoader:boolean = false;
  constructor(private reportService:ReportService, private adminService:AdminService, private _lookupService:LookUpService, private router:Router,private menuService:MenuService,private generalService: GeneralService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {      
      this.getPermissions(parseInt(obj['menuId'])??0);
    }
     //this.getDistributorDetails();
    this.bindReportDDL();   
    this.requestData.formTitle="titles"; 
    this.requestData.filterFormFields=[];
  }  

  async bindReportDDL(){
    let response = await this.reportService.GetReportDDL();
    if (response?.isSuccess) {
      this.reportList = response.result;
    }
  }

  ngOnInit() {
  }
  getSavedData(data:any){ 
    debugger; 
    //this.isFirstLoad = false;
    // if(data){
    //   let frm = data.data;
    //   if(frm != undefined && frm.filterFormFields != undefined && frm.filterFormFields.length > 0 &&
    //     this.required_input_fields != undefined && this.required_input_fields.filterFormFields != undefined && this.required_input_fields.filterFormFields.length > 0
    //   ){
    //     for(let j =0;j<frm.filterFormFields.length;j++){
    //       if(frm.filterFormFields != undefined){
    //         let v = frm.filterFormFields[j];
    //         let v_v = this.required_input_fields.filterFormFields[j];
    //         v_v.selectedValue = v.selectedValue;
    //         //level2
    //         if (v.cascadeItems && v.cascadeItems.filterFormFields && v.cascadeItems.filterFormFields.length > 0 &&
    //           v_v.cascadeItems && v_v.cascadeItems.filterFormFields && v_v.cascadeItems.filterFormFields.length > 0 
    //         ) {
    //           for(let k =0;k<v.cascadeItems.filterFormFields.length;k++){
    //             let isValid2:boolean = true;
    //             let v2 = v.cascadeItems.filterFormFields[k];
    //             let v_v2 = v_v.cascadeItems.filterFormFields[k];
    //             v_v2.selectedValue = v_v.selectedValue;
    //             //level3
    //             if (v2.cascadeItems && v2.cascadeItems.filterFormFields && v2.cascadeItems.filterFormFields.length > 0) {
    //               for(let l =0;l<v2.cascadeItems.filterFormFields.length;k++){
    //                 let isValid3:boolean = true;
    //                 let v3 = v2.cascadeItems.filterFormFields[l];
    //                 let v_v3 = v_v.cascadeItems.filterFormFields[l];
    //                 v_v3.selectedValue = v_v2.selectedValue;
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
  }

  async applyButtonClick(data:any){  
    if(this.isDynamicFormIsValid()){
      this.showLoader = true;
      this.graphdata = [];
      this.visibleColumnData = []; 
        this.visibleColumnsId = [];
      let res = await this.reportService.GenerateReport(this.requestData);  
      if (res != null && res.result) {
        this.showLoader = false;
        this.graphdata = res.result.data;
        let index=3;
        let sort:string='asc';
        console.log(this.graphdata.sort( (a, b) => {
          if(sort == 'desc')
          {
            if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
              return -1;
            }
            if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
                return 1;
            }          
          }
          else
          {
            if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
              return -1;
            }
            if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
                return 1;
            }  
          }
          return index;
        }));
        this.graphHeader = res.result.header;
        this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
        this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
      }
      else{
        this.showLoader = false;
      }
    }
  }

  isDynamicFormIsValid():boolean{
    this.requestData.filterFormFields=[];
    let count = 0; 
    let frm = this.required_input_fields;
    if(frm != undefined && frm.filterFormFields != undefined && frm.filterFormFields.length > 0){
      for(let j =0;j<frm.filterFormFields.length;j++){
        if(frm.filterFormFields != undefined){
          let isValid:boolean = true;
          let v = frm.filterFormFields[j];
          if(v.isVisible == true && (v.isRequired == true && v.selectedValue == "" || 
            ((v.minLength??0) > 0 && (v.minLength??0) > 0 && ((v.selectedValue?.length??0) < (v.minLength??0) || (v.selectedValue?.length??0) > (v.maxLength??0))) ||
            ((v.pattern??"") != "" && !v.selectedValue?.match(v.pattern??""))) 
          ){
            count ++;
            isValid = false;
          } 
          v.isValid = isValid; 
          this.requestData.filterFormFields.push({id:v.id,selectedValue:v.selectedValue});
          //level2
          if (v.cascadeItems && v.cascadeItems.filterFormFields && v.cascadeItems.filterFormFields.length > 0) {
            for(let k =0;k<v.cascadeItems.filterFormFields.length;k++){
              let isValid2:boolean = true;
              let v2 = v.cascadeItems.filterFormFields[k];
              if(v2.isVisible == true && (v2.isRequired == true && v2.selectedValue == "" || 
                ((v2.minLength??0) > 0 && (v2.minLength??0) > 0 && ((v2.selectedValue?.length??0) < (v2.minLength??0) || (v2.selectedValue?.length??0) > (v2.maxLength??0))) ||
                ((v2.pattern??"") != "" && !v2.selectedValue?.match(v2.pattern??""))) 
              ){
                count ++;
                isValid2 = false;
              } 
              v2.isValid = isValid2; 
              this.requestData.filterFormFields.push({id:v2.id,selectedValue:v2.selectedValue});
              //level3
              if (v2.cascadeItems && v2.cascadeItems.filterFormFields && v2.cascadeItems.filterFormFields.length > 0) {
                for(let l =0;l<v2.cascadeItems.filterFormFields.length;k++){
                  let isValid3:boolean = true;
                  let v3 = v2.cascadeItems.filterFormFields[l];
                  if(v3.isVisible == true && (v3.isRequired == true && v3.selectedValue == "" || 
                    ((v3.minLength??0) > 0 && (v3.minLength??0) > 0 && ((v3.selectedValue?.length??0) < (v3.minLength??0) || (v3.selectedValue?.length??0) > (v3.maxLength??0))) ||
                    ((v3.pattern??"") != "" && !v3.selectedValue?.match(v3.pattern??""))) 
                  ){
                    count ++;
                    isValid3 = false;
                  } 
                  v3.isValid = isValid3; 
                  this.requestData.filterFormFields.push({id:v3.id,selectedValue:v3.selectedValue});
                }
              }
            }
          }
        }
      }
    }
    else{
      count = 1; 
    }    
     return count == 0;
   }
  
  async reportChange(event:any){
    this.graphdata = [];
    this.visibleColumnData = []; 
    this.visibleColumnsId = [];
    this.requestData.for = event.target.value;
    debugger; 
     let selectedReport = this.reportList?.filter((f:any) => {return f.value == event.target.value});
     this.reportTitle = selectedReport?.map((m:any) => { return m.text})?.[0];
    if(event.target.value != ""){
      let jsonString = selectedReport?.map((m:any) => { return m.text1})?.[0];
      if(jsonString != null && jsonString != undefined && jsonString != ''){
        console.log(jsonString);
        //let dddd = JSON.stringify(jsonString);
        let frm = JSON.parse(jsonString);
        if(frm && frm.filterFormFields && frm.filterFormFields?.length > 0)
        {
          for(let j =0;j<frm.filterFormFields.length;j++){
            if(frm.filterFormFields != undefined){
              let v = frm.filterFormFields[j];
             if(v.type?.toLowerCase()?.indexOf('multiselect') != -1){
              if(v.id?.toLowerCase()?.indexOf('agent') != -1){
                v.options = await this.loadAgentList();
              }
              if(v.id?.toLowerCase()?.indexOf('inscomp') != -1){
                v.options = await this.loadInsurancePartners();
              }
             }
              //level2
              if (v.cascadeItems && v.cascadeItems.filterFormFields && v.cascadeItems.filterFormFields.length > 0) {
                for(let k =0;k<v.cascadeItems.filterFormFields.length;k++){
                  let v2 = v.cascadeItems.filterFormFields[k];
                  
                  if(v2.type?.toLowerCase()?.indexOf('multiselect') != -1){
                    if(v2.id?.toLowerCase()?.indexOf('agent') != -1){
                      v2.options = await this.loadAgentList();
                    }
                    if(v2.id?.toLowerCase()?.indexOf('inscomp') != -1){
                      v2.options = await this.loadInsurancePartners();
                    }
                   }
                  //level3
                  if (v2.cascadeItems && v2.cascadeItems.filterFormFields && v2.cascadeItems.filterFormFields.length > 0) {
                    for(let l =0;l<v2.cascadeItems.filterFormFields.length;k++){
                      let v3 = v2.cascadeItems.filterFormFields[l];
                      if(v3.type?.toLowerCase()?.indexOf('multiselect') != -1){
                        if(v3.id?.toLowerCase()?.indexOf('agent') != -1){
                          v3.options = await this.loadAgentList();
                        }
                        if(v3.id?.toLowerCase()?.indexOf('inscomp') != -1){
                          v3.options = await this.loadInsurancePartners();
                        }
                       }
                    }
                  }
                }
              }
            }
          }
        }
        this.required_input_fields = frm;
      }
      else
      {
        this.required_input_fields = {};
      }
    }
    else
    {
      this.required_input_fields = {};
    }
  }


  async loadAgentList(){
    let item:Item|undefined;
    let res = await this.adminService.AgentDropDown();
    if (res != null && res.result) {
      //this.agentList = res.result.map((item:any)=> {return {text:item.name,value:item.uniqueUserId,id:item.uniqueUserId}});
      //this.agentList = 
      item = res.result.map((item:any)=> {return {name:item.name,value:item.uniqueUserId,id:item.uniqueUserId,checked:false}});
      
      //geographicalLocationsList.map((m:any)=> {return {id:m,name:m,checked:selectedItems.includes(m)}});
      // let selectedAgent = this.agentList.filter((f:any)=>{return f.id == this.generalService.getUniqueuserid()}).map((m:any)=>{return m.text});        
      // this.agentName =.023 selectedAgent != null && selectedAgent != undefined && selectedAgent.length > 0 ?  selectedAgent[0] : "";
    }
    return item;
  }

  async loadInsurancePartners()
  {
    let item:Item|undefined;
    let response = await this._lookupService.GetInsurancePartnersList();
      if (response?.isSuccess) {
        item = response.result.map((m:any)=> {return {name:m.insuranceName,value:m.insuranceId,id:m.insuranceId,checked:false}});
      }
    return item;
  }

  // constructor(private adminService: AdminService, private router:Router,private menuService:MenuService,private generalService: GeneralService) {
  //     let obj = this.router.getCurrentNavigation()?.extras?.state;
  //     if(obj)
  //     {      
  //       this.getPermissions(parseInt(obj['id'])??0);
  //     }
  //      this.getDistributorDetails();
  //   }
  
  async getDistributorDetails() {
      const res = await this.adminService.DistributorDetails1();    
      if (res != null && res.result) {
        this.graphdata = res.result.data;
        let index=3;
        let sort:string='asc';
        console.log(this.graphdata.sort( (a, b) => {
          if(sort == 'desc')
          {
            if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
              return -1;
            }
            if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
                return 1;
            }          
          }
          else
          {
            if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
              return -1;
            }
            if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
                return 1;
            }  
          }
          return index;
        }));
        this.graphHeader = res.result.header;
        this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
        this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
      }
    }
  
    onActionClick(data:any)
    {
      if(data)
      {
        if(data.action=="View")
        {
          this.router.navigateByUrl(this.viewUrl,{ state: { id:data.id }});
        }
        else if(data.action=="Edit")
        {
          this.router.navigateByUrl(this.editUrl,{ state: { id:data.id }});
        } 
      }
    }
  
    onCreateBtnClick(data:any)
    {
      this.router.navigate([this.createUrl]);
    }
  
    async getPermissions(menuId:number)
    {
      let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
      let res = await this.menuService.GetMenuPermissionsByUserId(obj);
      if(res && res.isSuccess)
      {
        if(res.result.userMenus.length > 0)
        {
          res.result.userMenus.forEach((element:any) => {
            if(element.permissionName.toLowerCase() =="create")
            {
              this.canCreate = true;
              this.createUrl = element.menuCommand;
            }
            else if(element.permissionName.toLowerCase() =="edit")
            {
              this.canEdit = true;
              this.editUrl = element.menuCommand;
            }
            else if(element.permissionName.toLowerCase() =="view")
            {
              this.canView = true;
              this.viewUrl = element.menuCommand;
            }
            else if(element.permissionName.toLowerCase() =="delete")
            {
              this.canDelete = true;
              this.deleteUrl = element.menuCommand;
            }
          });
        }      
      }
    }
}
